// extracted by mini-css-extract-plugin
export default {"coverImage":"Zine_coverImage__T6GfQ","zineDesc":"Zine_zineDesc__vAGX7","zineTitle":"Zine_zineTitle__9ask8","coverLink":"Zine_coverLink__W2Rvj"};